import request from "@/utils/request";

export function getWatermarkConfig() {
  return request({
    url: "/Common/Watermark/GetCurrentUserConfig",
    method: "get",
  });
}
